import * as Yup from "yup";
export const LeadAdditionalDetailsSchema = Yup.object({
  quotationNumber: Yup.string(),
  softwareDemoScreenshot: Yup.mixed(),
  siteInspectionId: Yup.string(),
  bankLoanStatus: Yup.string(),
  bankLoanDocument: Yup.mixed(),
  subsidyStatus: Yup.string(),
  subsidyDocumentId: Yup.number(),
  workOrder: Yup.mixed(),
  projectTrackingId: Yup.number(),
});

export const LeadAdditionalDetailsInfo = {
  quotationNumber: "",
  softwareDemoScreenshot: "",
  siteInspectionId: "",
  bankLoanStatus: "",
  bankLoanDocument: "",
  subsidyStatus: "",
  subsidyDocumentId: "",
  workOrder: "",
  projectTrackingId: "",
};
